/*
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/typography'),
      require('@tailwindcss/aspect-ratio'),
    ],
  }
  ```
*/
import { useState, useEffect, useContext, useRef } from "react";
import { Disclosure, RadioGroup, Tab } from "@headlessui/react";
import { StarIcon } from "@heroicons/react/20/solid";
import {
  ClipboardDocumentCheckIcon,
  DocumentDuplicateIcon,
  HeartIcon,
  MinusIcon,
  PlusIcon,
} from "@heroicons/react/24/outline";
import { useAxios, useAxiosSeconde } from "../api/api";
import { useParams, useNavigate } from "react-router-dom";
import { Context } from "../context/ContextProvider";
import Notifications from "../components/Notifications";
import AlertEditProduct from "../components/AlertEditProduct";
import i18n from "../i18n/i18n";
import EditorTextParser from "../components/EditorTextParser";
import exampleData from "../data/exampleData";
import Editor from "../components/Editor";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function DetailProduct({ t }) {
  const { _id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const {
    categories,
    items,
    setItems,
    addOrder,
    setOrders,
    orders,
    newList,
    setNewList,
    amountOfItemsInCart,
    handleAddProduct,
    cartItmes,
    setCartItems,
    handleRemoveProduct,
    totalPrice,
    setCategories,
    setCompany,
    setShow,
    show,
  } = useContext(Context);

  const [select, setSelect] = useState(false);

  const handleNotification = () => {
    setShow(true);
    setTimeout(() => {
      setShow(false);
      setSelect(false);
    }, 1000);
  };

  const textCutFunc = (text) =>
    `${text
      .trim()
      .split(" ")
      .splice(0, text?.length > 25 ? 3 : 4)
      .join(" ")}  ${text?.length > 25 ? "..." : ""}`;

  const { response, loading, error } = useAxios({
    method: "GET",
    url: `/products/detail/${_id}`,
    headers: {
      // no need to stringify
      accept: "*/*",
    },
    // data: {  // no need to stringify
    //     userId: 1,
    //     id: 19392,
    //     title: 'title',
    //     body: 'Sample text',
    // },
  });

  const cartFull =
    false &&
    localStorage.getItem("Order") != null &&
    JSON.parse(localStorage.getItem("Order"))?.length > 0
      ? JSON.parse(localStorage.getItem("Order"))
          .filter((p) => p.company_id === response && response[0].company_id)
          .map((item) => item.qty)
          .reduce((previous, item) => previous + item, 0)
      : 0;

  const { data, loadingSeconde, errorSeconde } = useAxiosSeconde({
    method: "GET",
    url: `/companies/company-limits/${localStorage.getItem("CN")}`,
    headers: {
      accept: "*/*",
    },
  });
  const [dataa, setDataa] = useState("");
  const oneFetch = useRef(true);
  // useEffect(() => {
  //   if (oneFetch.current || loading === false) {
  //     oneFetch.current = false;
  //     localStorage.getItem("Order") != null &&
  //       setCartItems(JSON.parse(localStorage.getItem("Order")));

  //     setTimeout(() => {
  //       setCategories([
  //         "all",
  //         ...new Set(
  //           response
  //             ?.map((item) => item.category)
  //             .filter((category) => category.trim() !== ""),
  //         ),
  //       ]);

  //       // setCompany(data);
  //     }, 100);
  //   }
  // }, [loading]);

  useEffect(() => {
    if (loading == false) {
      response &&
        response[0]?.description?.length > 0 &&
        response[0]?.description.startsWith("{") &&
        setDataa(response[0]?.description);
      setIsLoading(false);
    }
  }, [loading]);

  const updateClipboard = (newClip) => {
    navigator.clipboard.writeText(newClip).then(
      () => {
        handleNotification();
      },
      () => {
        console.log("clipboard write failed");
      },
    );
  };

  return (
    <>
      <Notifications title={t("copyText")} />

      {loading ? (
        <div className="flex w-full items-center justify-center py-20">
          <div className="flex items-center justify-center space-x-1 text-sm text-gray-700 rtl:space-x-reverse">
            <svg
              fill="none"
              className="h-20 w-20 animate-spin"
              viewBox="0 0 32 32"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                clipRule="evenodd"
                d="M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z"
                fill="currentColor"
                fillRule="evenodd"
              />
            </svg>
          </div>
        </div>
      ) : (
        <div className="max-w-2xl px-4 py-2 sm:mx-auto sm:px-6 sm:py-5 lg:max-w-7xl lg:px-8">
          <div className="mb-2 flex flex-row items-center justify-between ">
            <div className="">
              <button
                onClick={() => {
                  // handleAddProduct(response[0]) & (cartItmes?.length > 0) &&
                  //   localStorage.setItem("Order", JSON.stringify(cartItmes));
                  // handleNotification(response[0]._id);
                  navigate(`/edite-product`, {
                    state: {
                      product: response[0],
                      //...values
                    },
                  });
                }}
                className="flex w-full justify-center rounded-md border bg-gray-400 px-3 py-2 text-sm font-semibold  text-white  shadow-sm hover:bg-indigo-500 focus:ring-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2  focus-visible:outline-indigo-600 xl:py-3 2xl:text-xl "
              >
                {show && select ? (
                  <>
                    <svg
                      aria-hidden="true"
                      role="status"
                      className="inline h-5 w-5 animate-spin text-white ltr:mr-3 rtl:ml-3"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="#E5E7EB"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentColor"
                      />
                    </svg>
                  </>
                ) : (
                  t("editeProduct")
                )}
              </button>
            </div>
          </div>
          <div className="lg:grid lg:grid-cols-2 lg:items-start lg:gap-x-8  ">
            {/* Image gallery */}
            {/* Image selector */}
            <Tab.Group as="div" className="flex flex-col-reverse">
              <div className="mx-auto mt-6 w-full max-w-2xl sm:block lg:max-w-none">
                <Tab.List className="grid grid-cols-4 gap-6">
                  {response &&
                    response[0].image.split(",").map((image, index) => (
                      <Tab
                        key={index}
                        className="relative flex h-24 cursor-pointer items-center justify-center rounded-md bg-white text-sm font-medium uppercase text-gray-900 hover:bg-gray-50 focus:outline-none focus:ring focus:ring-opacity-50 focus:ring-offset-4"
                      >
                        {({ selected }) => (
                          <>
                            <span className="sr-only"> {image} </span>
                            <span className="absolute inset-0 overflow-hidden rounded-md">
                              <img
                                src={image}
                                alt=""
                                className="h-full w-full object-cover object-center "
                              />
                            </span>
                            <span
                              className={classNames(
                                selected
                                  ? "ring-indigo-500"
                                  : "ring-transparent",
                                "pointer-events-none absolute inset-0 rounded-md ring-2 ring-offset-2",
                              )}
                              aria-hidden="true"
                            />
                          </>
                        )}
                      </Tab>
                    ))}
                </Tab.List>
              </div>

              <Tab.Panels className="aspect-h-1 aspect-w-1 w-full">
                {response[0].image
                  ? response[0].image.split(",").map((image, key) => (
                      <Tab.Panel key={key}>
                        <img
                          src={image}
                          alt={key}
                          className="h-full w-full object-cover object-center sm:rounded-lg"
                        />
                      </Tab.Panel>
                    ))
                  : ""}
              </Tab.Panels>
            </Tab.Group>

            {/* Product info */}
            <div className="mt-10 px-4 sm:mt-16 sm:px-0 lg:mt-0">
              <div className="flex flex-row items-start justify-between">
                <h1 className="text-1xl font-bold tracking-tight text-gray-900 md:text-3xl">
                  {response[0].name ? response[0].name : ""}
                </h1>
              </div>
              <div className="mt-3 flex flex-row items-center gap-2">
                <h1 className="text-md tracking-tight text-gray-500 md:text-xl">
                  {t("sin") + ":"}
                </h1>
                <h1 className="text-md tracking-tight text-gray-500 md:text-xl">
                  {response[0].sin ? response[0].sin : ""}
                </h1>
                <button
                  onClick={() => updateClipboard(response[0].sin)}
                  type="button"
                  className={classNames(
                    show ? "bg-green-100 text-green-600" : "text-gray-400",
                    "relative -ml-px inline-flex items-center gap-x-1.5 rounded px-3 py-2 text-sm font-semibold text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50",
                  )}
                >
                  {show ? (
                    <ClipboardDocumentCheckIcon
                      className=" h-5 w-5 animate-bounce text-green-600"
                      aria-hidden="true"
                    />
                  ) : (
                    <DocumentDuplicateIcon
                      className=" h-5 w-5 text-gray-400"
                      aria-hidden="true"
                      // onClick={() => copyToClipboard(response.url)}
                    />
                  )}
                  <p className="hidden sm:block">{t("copy")}</p>
                </button>
              </div>
              <div className="mt-3">
                <h2 className="sr-only">Product information</h2>
                <p className="text-1xl tracking-tight text-green-500 md:text-2xl">
                  {response[0].unit
                    ? response[0].unit.toFixed(2) + " " + t("sar") + " "
                    : ""}
                  <span className=" text-red-700 line-through">
                    {response[0].basicPrice
                      ? response[0].basicPrice.toFixed(2) + " " + t("sar") + " "
                      : ""}
                  </span>
                </p>
              </div>
              <div className="mt-2">
                <h3 className="sr-only">Description</h3>

                {/* <div
                  className="space-y-6 text-base text-gray-700"
                  dangerouslySetInnerHTML={{
                    __html: response[0].description
                      ? response[0].description
                      : "",
                  }}
                /> */}
              </div>
              {/* <EditorTextParser
                // className=" "
                // className="space-y-6  text-gray-700"
                data={dataa}
              /> */}
              {isLoading === false ? (
                <Editor
                  data={dataa.length > 0 ? JSON.parse(dataa) : ""}
                  setData={setDataa}
                  readOnly={true}
                />
              ) : (
                <div className="flex w-full items-center justify-center py-20">
                  <div className="flex items-center justify-center space-x-1 text-sm text-gray-700 rtl:space-x-reverse">
                    <svg
                      fill="none"
                      className="h-20 w-20 animate-spin"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        clipRule="evenodd"
                        d="M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z"
                        fill="currentColor"
                        fillRule="evenodd"
                      />
                    </svg>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
